import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Industries", href: "#industries" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,box-shadow] duration-500 border-b ${
        scrolled ? "glass border-[#00F2FE]/15 shadow-[0_8px_40px_-12px_rgba(0,242,254,0.15)]" : "border-transparent bg-[#051221]/40 backdrop-blur-md"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/images/logo-mark.png"
            alt="Ocean Mind AI logo"
            className="w-10 h-10 rounded-full ring-1 ring-[#00F2FE]/40 group-hover:ring-[#00F2FE]/80 group-hover:shadow-[0_0_18px_-2px_rgba(0,242,254,0.6)] transition-[box-shadow] duration-300"
          />
          <span className="font-['Outfit'] font-semibold text-lg tracking-tight text-[#E8F1F5]">
            Ocean<span className="gradient-text">Mind</span> AI
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm text-[#8AA1B1] hover:text-[#00F2FE] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden md:block">
          <button
            data-testid="nav-cta-button"
            onClick={() => go("#contact")}
            className="rounded-full px-6 py-2.5 text-sm font-medium bg-[#00F2FE]/15 text-[#00F2FE] border border-[#00F2FE]/50 hover:bg-[#00F2FE]/35 hover:shadow-[0_0_25px_-5px_rgba(0,242,254,0.6)] transition-[background-color,box-shadow] duration-300"
          >
            Start a Project
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#E8F1F5]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass border-t border-[#00F2FE]/10 px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-left text-[#8AA1B1] hover:text-[#00F2FE] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta"
            onClick={() => go("#contact")}
            className="rounded-full px-6 py-2.5 text-sm font-medium bg-[#00F2FE]/15 text-[#00F2FE] border border-[#00F2FE]/50 w-fit"
          >
            Start a Project
          </button>
        </div>
      )}
    </header>
  );
};
